import { classnames } from '@aibees/shared/utils';
import { Box } from '@mui/material';
import { memo } from 'react';
import { SearchCardListNameFilter } from '../search-card-list-name-filter';
import { SearchListCardTypeFilter } from '../search-list-card-type-filter';
import * as Styled from './styles';
import * as SX from './sx';
import type { SearchListCardFiltersProps as Props } from './types';

export const SearchListCardFilters = memo(({ className }: Props) => {
  return (
    <Styled.Wrapper
      className={classnames('SearchListCardFilters', className)}
      sx={SX.root}
    >
      <Box sx={{ flex: 1 }}>
        <SearchCardListNameFilter />
      </Box>

      <SearchListCardTypeFilter />
    </Styled.Wrapper>
  );
});

SearchListCardFilters.displayName = 'SearchListCardFilters';
